import { App } from 'vue';

declare module 'vue' {
  interface ComponentCustomProperties {
    $tabs: TabsService;
  }
}

export interface TabsService {
  close(): void;
  closeTab(fullPath: string): void;
}

export function createTabsPlugin() {
  let _closeTab: ((fullPath: string) => void) | null = null;
  let _getFullPath: (() => string) | null = null;

  const service: TabsService = {
    close() {
      if (_closeTab && _getFullPath) {
        _closeTab(_getFullPath());
      }
    },
    closeTab(fullPath: string) {
      if (_closeTab) {
        _closeTab(fullPath);
      }
    },
  };

  return {
    install(app: App) {
      app.config.globalProperties.$tabs = service;
    },
    service,
    connect(closeTab: (fullPath: string) => void, getFullPath: () => string) {
      _closeTab = closeTab;
      _getFullPath = getFullPath;
    },
  };
}

export const tabsPlugin = createTabsPlugin();
